import { useEffect, useState } from "react";
import InputAHSF from "../../../Components/InputAHSF";
import { useDispatch, useSelector } from "react-redux";
import ButtonAHSF from "../../../Components/ButtonAHSF";

import Swal from "sweetalert2";
import $ from "jquery";
import { useNavigate } from "react-router-dom";
import { AddReturnComments } from "../../../Redux/Reducers/ReportStage/ReturnComments";
import TextAreaAHSF from "../../../Components/TextAreaAHSF";

const NoteForm = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const userInfo = useSelector((state) => state.UserInfo.UserInfo);
  console.log(userInfo.userToken.userGuid, "userInfo");

  const [Note, setNote] = useState("");
  const [NoteValidation, setNoteValidation] = useState(false);

  // Fetch existing activity on edit

  
  const Validation = () => {
    const isEmpty = !Note || Note.trim() === "";
    setNoteValidation(isEmpty);
    return !isEmpty;
  };

  const AddNote = () => {
    if (Validation()) {
      dispatch(
        AddReturnComments({
          comments: Note.trim(),
          reportStageId: props.reportStageId,
          userGuid: userInfo.userToken.userGuid,
          createTime: new Date().toISOString(),
        })
      );

      Swal.fire({
        position: "center",
        icon: "success",
        title: "تمت الأضافة بنجاح",
        showConfirmButton: false,
        timer: 1500,
      });

      $(".close-btn").trigger("click");
    }
  };

  return (
    <>
      <TextAreaAHSF
        fieldsName="Note"
        show={true}
        // disabled={props.shouldDisableFields}
        // defaultValue={
        //   props.Action == "edit" ? GetActivitiesByIdResult?.activitiesName : ""
        // }
        onChange={(e) => setNote(e.target.value)}
        showValidationMessage={NoteValidation}
        validationMessage="حقل إجباري"
      />

      <div className="ConainerButtonAHSF">
        <ButtonAHSF onClick={AddNote} text="حفظ" show={true} />
      </div>
    </>
  );
};

export default NoteForm;
